<div class="intro-container">
  <!-- HOW IT WORKS -->
  <div class="section">
    <h3 class="section-title">
      <i class="bi bi-journal-check"></i> How It Works
    </h3>

    <div class="steps">
      <div class="step" *ngFor="let step of [1,2,3,4]; let i = index">
        <div class="step-number">{{ step }}</div>
        <p class="step-text" *ngIf="i === 0">
          <strong>Ai interviews you based on your selected role and round</strong> (and your resume/JD if uploaded).
        </p>
        <p class="step-text" *ngIf="i === 1">
          <strong>The AI asks questions one by one in real-time,</strong> just like a natural conversation.
        </p>

        <p class="step-text" *ngIf="i === 2">
          The next question appears <strong>as soon as your answer is processed,</strong> making the interview smooth
          and continuous </p>

        <p class="step-text" *ngIf="i === 3">
          You can <strong>exit the interview anytime</strong> using the Exit Interview option.
        </p>
      </div>
    </div>
  </div>

  <!-- EVALUATION CRITERIA -->
  <div class="section">
    <h3 class="section-title criteria">
      <i class="bi bi-clipboard-check"></i> Evaluation Criteria
    </h3>
    <p class="criteria-sub">Your performance will be scored on these key areas</p>

    <div class="criteria-grid">
      <div class="criteria-card" *ngFor="let item of criteria">
        <div class="criteria-header">
          <i class="bi" [ngClass]="item.icon"></i>
          <span>{{ item.label }}</span>
        </div>
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="item.progress" [style.background]="item.color"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- READY SECTION -->
  <div class="shine-box">
    <div class="shine-icon">
      <i class="bi bi-megaphone-fill"></i>
    </div>
    <div class="shine-content">
      <h4>🔥 Get Ready to Shine!</h4>
      <p>
        Your responses will be recorded and analyzed by our AI to provide personalized feedback.
        Take a deep breath, think before answering, and show your best self. Remember, this is practice —
        the more you do it, the better you’ll get!
      </p>
      <ul>
        <li>Recording will start when you begin</li>
      </ul>
    </div>
  </div>

  <!-- CTA BUTTON -->
  <div class="cta-section">
    <button class="ready-btn">
      <i class="bi bi-rocket-takeoff"></i> Ready to Showcase Your Skills?
    </button>
    <p class="cta-sub">
      You’ve got this! Remember to stay calm, be yourself, and show your problem-solving approach.
    </p>
  </div>

  <!-- ACTION BAR -->
  <div class="action-bar">
    <button class="back-btn" (click)="back.emit()">
      <i class="bi bi-arrow-left"></i> Back
    </button>

    <button class="start-btn" [disabled]="isStarting" (click)="startInterview()"
	*hasPermission="PermissionForStudents.INTERVIEW_TAKE">	
      <ng-container *ngIf="!isStarting; else loading">
        <i class="bi bi-play-circle"></i>
        <span>Start Interview</span>
      </ng-container>

      <ng-template #loading>
        <div class="spinner"></div>
        <span>Starting...</span>
      </ng-template>
    </button>
  </div>
</div>